import "sb-js-extends";
import { isNumber } from "util";
import { getCurrentTime } from "sb-resp-utils";
import { GameStatus } from "../contracts";
// import { computed, observable } from "mobx";
export class EventResult {
    constructor(event, openGameHandler, dateTimeData, dict) {
        this.componentType = event.isLive ? "InPlayEvent" : "UpcommingEvent";
        this.id = event.id;
        this.entityType = event.entityType;
        this.eventName = event.eventName;
        this.leagueName = event.leagueName;
        this.score = event.score;
        this.status = event.status;
        this.participants = event.participants;
        this.isLive = event.isLive;
        this.isGoingLive = event.isGoingLive;
        this.liveGameState = event.liveGameState;
        this.isTeamSwap = event.isTeamSwap;
        this.sportId = event.sportId;
        this.startEventDate = Date.fromISO(event.startEventDate);
        this.setTimeZone(dateTimeData.timeZone);
        this.dict = dict;
        this.openGameHandler = openGameHandler;
        this.dateTimeData = dateTimeData;
        this.clickHandler = this.clickHandler.bind(this);
    }
    setTimeZone(timeZone) {
        this.localStartEventDate = this.startEventDate ? getCurrentTime(this.startEventDate, timeZone) : undefined;
    }
    getISODate(dateISOString, timeZone) {
        let convertedDate = Date.fromISO(dateISOString);
        return convertedDate ? getCurrentTime(convertedDate, timeZone) : undefined;
    }
    get getDateTime() {
        if (this.isInStartsTimeState) {
            return this.getStartsInTime;
        }
        const gameTime = this.gameTime ? this.dict.ClockMins.format(this.gameTime) : "";
        const gamePart = this.dict[this.gamePart] || this.gamePart;
        const gameStatus = `${gamePart} ${gameTime}`;
        return gameStatus.trim() || this.dict.LiveEvent;
    }
    get getStartsInTime() {
        const minutes = Math.floor((this.milisecondsToGameStart / 1000) / 60);
        return `${this.dict.StartsIn} ${this.dict.ClockMins.format(minutes.toString())}`;
    }
    //get how much time leave before game start in miliseconds
    get milisecondsToGameStart() {
        const now = this.getISODate(new Date().toISOString(), this.dateTimeData.timeZone);
        if (!now || !this.localStartEventDate || now >= this.localStartEventDate) {
            return 0;
        }
        else {
            return this.localStartEventDate.getTime() - now.getTime();
        }
    }
    get isInStartsTimeState() {
        return this.isLive && this.status === GameStatus.NotStarted;
    }
    get firstTeamName() {
        const participant = this.getParticipant(this.isTeamSwap ? "Away" : "Home");
        return participant ? participant.name : "";
    }
    get secondTeamName() {
        const participant = this.getParticipant(this.isTeamSwap ? "Home" : "Away");
        return participant ? participant.name : "";
    }
    get firstTeamScore() {
        if (!this.score) {
            return "";
        }
        return this.isTeamSwap ? this.score.awayScore : this.score.homeScore;
    }
    get secondTeamScore() {
        if (!this.score) {
            return "";
        }
        return this.isTeamSwap ? this.score.homeScore : this.score.awayScore;
    }
    get formattedStartDate() {
        return this.formatDate(this.dateTimeData.dateFormat);
    }
    get formattedStartTime() {
        return this.formatDate(this.dateTimeData.timeFormat);
    }
    formatDate(format) {
        return !this.localStartEventDate
            ? "--"
            : this.localStartEventDate.formatDate(format);
    }
    get gamePart() {
        return this.liveGameState && this.liveGameState.gamePart ? this.liveGameState.gamePart : "";
    }
    get gameTime() {
        if (!this.liveGameState || !isNumber(this.liveGameState.gameTime) || this.gamePart.startsWith("Break")) {
            return "";
        }
        return Math.ceil(this.liveGameState.gameTime / 60);
    }
    clickHandler(event) {
        this.openGameHandler(event, this);
    }
    getParticipant(venueRole) {
        return this.participants.find(participant => participant.venueRole === venueRole);
    }
}
//# sourceMappingURL=EventResult.js.map